import createPersistedState from 'vuex-persistedstate'

export const namespaced = true
export const namespace = 'Client/Lairdnd'

const MAX_LAST_ADDRESSES = 3

const types = {
    SET_ADDRESS: 'SET_ADDRESS',
}

export const state = {
  address: '',
  lastAddresses: [],
}

export const mutations = {
  [types.SET_ADDRESS](state, address) {
    state.address = address

    if (state.lastAddresses.includes(address)) {
      state.lastAddresses.splice(state.lastAddresses.indexOf(address), 1)
    } else {
      if (state.lastAddresses.length >= MAX_LAST_ADDRESSES) {
        state.lastAddresses.pop()
      }
    }

    state.lastAddresses.unshift(address)
  },
}

export const actions = {
    setAddress({ commit }, address) {
        commit(types.SET_ADDRESS, address)
    },
}

export const getters = {
  address: state => state.address,
  lastAddresses: state => state.lastAddresses,
}

export const plugins = [
    createPersistedState({
        paths: [
            `${namespace}`,
        ],
        key: namespace,
    }),
]
